export const ROUTE_PATH = '/location/:locationId';
